import {
  PulseFilters,
  PulsePaginatedFilters,
  pulseFiltersSchema,
  pulsePaginatedFiltersSchema,
} from './types'

import { api } from 'api'
import { z } from 'zod'

const fillPayNoticeByLocationResponse = z.array(
  z.object({
    avg_pay_long_notice: z.number().optional().nullable(),
    avg_pay_rate_with_company_bonus: z.number().optional().nullable(),
    avg_pay_short_notice: z.number().optional().nullable(),
    change_in_fill_long_vs_short_notice: z.number().optional().nullable(),
    change_in_pay_long_vs_short_notice: z.number().optional().nullable(),
    company_name: z.string(),
    fill_rate: z.number().optional().nullable(),
    fill_rate_long_notice: z.number().optional().nullable(),
    fill_rate_short_notice: z.number().optional().nullable(),
    late_notice_shifts: z.number().optional().nullable(),
    location_market: z.string(),
    workers_needed_final: z.number().optional().nullable(),
  })
)

export type FillPayNoticeByLocation = z.infer<
  typeof fillPayNoticeByLocationResponse
>

export async function getFillPayNoticeByLocation(
  filters: PulsePaginatedFilters,
  signal?: AbortSignal
) {
  const data = pulsePaginatedFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/fill_pay_notice_breakdown', data, {
      signal,
    })
    .then((response) => response.data)
    .then(fillPayNoticeByLocationResponse.parse)
}

export async function getFillPayNoticeByLocationCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/fill_pay_notice_breakdown/csv', data, {
      signal,
    })
    .then((response) => response.data)
}
